import _regeneratorRuntime from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import { browserSha256, browserSha512 } from "../lib/browser";
export function sha256(msg) {
  var result;
  return _regeneratorRuntime.async(function sha256$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _regeneratorRuntime.awrap(browserSha256(msg));

        case 2:
          result = _context.sent;
          return _context.abrupt("return", result);

        case 4:
        case "end":
          return _context.stop();
      }
    }
  });
}
export function sha512(msg) {
  var result;
  return _regeneratorRuntime.async(function sha512$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return _regeneratorRuntime.awrap(browserSha512(msg));

        case 2:
          result = _context2.sent;
          return _context2.abrupt("return", result);

        case 4:
        case "end":
          return _context2.stop();
      }
    }
  });
}
export function ripemd160(msg) {
  return _regeneratorRuntime.async(function ripemd160$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          throw new Error("Not supported for Browser async methods, use sync instead!");

        case 1:
        case "end":
          return _context3.stop();
      }
    }
  });
}